<template>
  <div>
    <TokenDialog v-model="editingHttpAuthToken" @refresh="loadSubusers" />


    <SubuserEditDialog
        :visible="editingSubuser.dialogVisible"
        :edit-mode="editingSubuser.editMode"
        :save-path="paths.saveUser"
        :roles="roles"
        :user="editingSubuser.user"
        :allow-users-editing="allowUsersEditing"
        :allow-setup-restrictions="allowSetupRestrictions"
        @update:visible="v => editingSubuser.dialogVisible = v"
        @refresh="loadSubusers"
    />

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <TableSpinner :loading="subusersLoading">
            <el-checkbox v-model="showLockedUsers" data-test="showBlockedUsers">Показывать заблокированных
              ({{ lockedUsersCount }})
            </el-checkbox>

            <el-table :data="subusersFiltered" style="width: 100%">
              <el-table-column prop="system_id" label="Логин" width="100"/>
              <el-table-column label="Ф.И.О" min-width="250">
                <template #default="scope">
                  {{ scope.row.info.lastname }}&nbsp;{{ scope.row.info.firstname }}&nbsp;{{ scope.row.info.patronymic }}
                  <br v-if="scope.row.active === 0"/>
                  <span style="color: red" v-if="scope.row.active === 0">(пользователь заблокирован)</span>
                </template>
              </el-table-column>
              <el-table-column prop="info.phone" label="Телефон" min-width="120"/>
              <el-table-column prop="info.email" label="E-mail" min-width="180"/>
              <el-table-column label="Роль" min-width="250">
                <template #default="scope">
                  {{ getRoleName(scope.row.privilege_role) }}
                </template>
              </el-table-column>
              <el-table-column v-if="showActionsColumn" label="" min-width="150">
                <template #default="scope">
                  <ActionsDropdown :data-test="`userActions-${scope.row.system_id}`">
                    <ActionButton icon="pencil-alt" @click="editSubuser(scope.row, true)"
                                  :data-test="`userActions-edit-${scope.row.system_id}`">Изменить
                    </ActionButton>
                    <ActionButton icon="lock" @click="editAuthToken(scope.row)"
                                  v-if="allowUsersEditing && switchDefaultManager === undefined">Токен авторизации
                    </ActionButton>
                    <ActionButton icon="copy" @click="editSubuser(scope.row)"
                                  v-if="allowUsersEditing">Создать по образцу
                    </ActionButton>
                    <ActionButton icon="eye" @click="switchDefaultManager(scope.row.system_id)"
                                  v-if="allowUsersEditing && switchDefaultManager !== undefined && scope.row.system_id !== defaultManager"
                                  >Назначить ответственным за новых пользователей
                    </ActionButton>
                    <ActionButton icon="ban" @click="blockUser(scope.row)"
                                  v-if="allowUsersEditing && scope.row.active === 1 && scope.row.system_id.includes('.')"
                                  :data-test="`userActions-block-${scope.row.system_id}`">Заблокировать
                    </ActionButton>
                    <ActionButton icon="check-circle" @click="unblockUser(scope.row)"
                                  v-if="allowUsersEditing && scope.row.active === 0 && scope.row.system_id.includes('.')"
                                  :data-test="`userActions-unblock-${scope.row.system_id}`">Разблокировать
                    </ActionButton>
                    <ActionButton icon="sign-out-alt"  @click="logoutEverywhere(scope.row)"
                                  v-if="allowUsersEditing && $store.getters.isSurrogateLogin"
                                  >Выйти везде
                    </ActionButton>
                    <ActionButton icon="times" type="remove" @confirm="removeUser(scope.row)"
                                  v-if="allowUsersEditing && scope.row.system_id.includes('.')"
                                  :data-test="`userActions-remove-${scope.row.system_id}`">Удалить
                    </ActionButton>
                  </ActionsDropdown>

                </template>
              </el-table-column>
            </el-table>
          </TableSpinner>
          <el-button v-if="allowUsersEditing" type="success" plain @click="editSubuser()" style="margin-top: 40px" data-test="addUser">
            <font-awesome-icon icon="plus" class="el-icon--left"></font-awesome-icon>
            Добавить пользователя
          </el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ActionsDropdown from "@shared/components/layout/actionsDropdown.component"
import ActionButton from "@shared/components/layout/actionButton.component"
import TokenDialog from "./dialogs/token-dialog.component"
import SubuserEditDialog from "./dialogs/subuser-edit-dialog/subuser-edit-dialog.component"

export default {
  name: "AccountUsers",
  components: {ActionsDropdown, ActionButton, TokenDialog, SubuserEditDialog},
  expose: ["loadSubusers"],
  props: {
    allowUsersEditing: Boolean,
    showActionsColumn: Boolean,
    allowSetupRestrictions: Boolean,
    paths: {
      type: Object,
      default: {
        getMySubusers: "/user/getMySubusers",
        getMyRoles: "/user/getMyRoles",
        revokeToken: "/user/revokeHttpToken",
        saveUser: "/user/saveSubuser",
        blockUser: "/user/block",
        unblockUser: "/user/unblock",
        removeUser: "/user/remove",
        logoutEverywhere: "/auth/extLogout"
      }
    },
    switchDefaultManager: Function,
    defaultManager: String
  },
  mounted() {
    this.loadSubusers()
  },
  computed: {
    lockedUsersCount() {
      return this.subusers.filter(u => u.active === 0).length
    },
    subusersFiltered() {
      if (this.showLockedUsers) return this.subusers
      return this.subusers.filter(u => u.active !== 0)
    }
  },
  methods: {
    getRoleName(roleId) {
      return (this.roles.find(r => r._id === roleId) || {}).title || ""
    },
    async loadSubusers() {
      this.subusersLoading = true
      let [subusersResp, rolesResp] = await Promise.all([
        this.axios.get(this.paths.getMySubusers),
        this.axios.get(this.paths.getMyRoles)
      ])
      this.subusers = subusersResp.data.sort((s1, s2) => s1.system_id === s2.system_id ? 0 : s1.system_id.indexOf('.') < 0 ? -1 : s2.system_id.indexOf('.') < 0 ? 1 : Number(s1.system_id.split('.')[1]) - Number(s2.system_id.split('.')[1]))
      this.roles = rolesResp.data
      this.subusersLoading = false
    },

    editSubuser(user, editMode = false){
      this.editingSubuser.editMode = editMode
      this.editingSubuser.user = user
      this.editingSubuser.roles = this.roles
      this.editingSubuser.dialogVisible = true
    },
    editAuthToken(user){
      this.editingHttpAuthToken.userId = user._id
      this.editingHttpAuthToken.token = user.httpAuthToken || ""
      this.editingHttpAuthToken.revokeTokenPath = this.paths.revokeToken
      this.editingHttpAuthToken.dialogVisible = true
    },
    async blockUser(user) {
      try {
        await this.axios.post(this.paths.blockUser, {userId: user._id})
        this.$gNotify(`Пользователь заблокирован`, "success")
        this.loadSubusers()
      } catch (e) {console.error(e)}
    },
    async unblockUser(user) {
      try {
        await this.axios.post(this.paths.unblockUser, {userId: user._id})
        this.$gNotify(`Пользователь разблокирован`, "success")
        this.loadSubusers()
      } catch (e) {console.error(e)}
    },
    async removeUser(user) {
      try {
        await this.axios.delete(this.paths.removeUser, {params: {userId: user._id}})
        this.$gNotify(`Пользователь удалён`, "success")
        this.loadSubusers()
      } catch (e) {console.error(e)}
    },
    async logoutEverywhere(user){
      let confirmed = await this.$confirm(`Подтвердите выход на всех устройствах для пользователя ${user.system_id}`).catch(e => {})
      if (confirmed){
        try {
          await this.axios.post(this.paths.logoutEverywhere, {system_id: user.system_id})
          this.$gNotify(`Все сессии пользователя ${user.system_id} прерваны`, "success")
        } catch (e) {console.error(e)}
      }
    }
  },
  data() {
    return {
      subusers: [],
      roles: [],
      showLockedUsers: false,
      subusersLoading: false,
      editingHttpAuthToken: {
        dialogVisible: false
      },
      editingSubuser: {
        dialogVisible: false,
        editMode: false,
        roles: [],
        user: null
      }
      // synonims: [],
      // synonimFormVisible: false,
      // userForSynonim: "",
      // newSynonim: "",
    }
  }
}
</script>